module.exports = __webpack_public_path__ + "img/CFM_Tagline_Left.467c7887.png";